import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import MessagePage from '@dashboard/components/pages/MessagePage';
import { Button, Stack } from '@mui/material';

export default function NotFoundPage() {
  return (
    <MessagePage
      icon="ERROR"
      title="Page not found"
      description="Sorry, this page is not available."
      action={
        <Stack spacing={1} direction="row" justifyContent="center">
          <ButtonLink variant="contained" href="/">
            Home
          </ButtonLink>
          <Button variant="contained" color="secondary" target="_blank" href="https://www.usewaypoint.com/help">
            Help
          </Button>
        </Stack>
      }
    />
  );
}
